module.exports = __webpack_public_path__ + "media/images/v2/thumb1-bced8f14387940227f9e6685d986e167.png";